export const getStreamingColumnTypes = "getStreamingColumnTypes";
export const getStreamingMeasures = "getStreamingMeasures";
export const getStreamingTimeshift = "getStreamingTimeshift";
export const getStreamingDomainGroups = "getStreamingDomainGroups";
export const executeStreamingQuery = "executeStreamingQuery";
export const executeStreamingRoFQuery = "executeStreamingRoFQuery";
export const getAllOtherTargetsRofResults = "getAllOtherTargetsRofResults";
export const executeExportStreamingQuery = "executeExportStreamingQuery";
export const executeStreamingScheduleQuery = "executeStreamingScheduleQuery";
